import { DeltaServerChangeFeed } from "@hds-products/delta-server-client";
import { ItemEngineStateClientEntity } from "../index.mjs";

class ItemEngineStateClientChangeFeed extends DeltaServerChangeFeed {
    static DEFAULT_PROJECTION = {};
    constructor(deltaServerClient, baseUri, customHeaderFn, projection = ItemEngineStateClientChangeFeed.DEFAULT_PROJECTION) {
        super(ItemEngineStateClientEntity, deltaServerClient, baseUri, ItemEngineStateClientEntity.prototype._meta.entityName, customHeaderFn, projection);
    }
}
export { ItemEngineStateClientChangeFeed };
export default ItemEngineStateClientChangeFeed;